import { computed } from "vue"
import { mapState } from "vuex"

export default function useSizeCount() {
  const filters = mapState("filter", {
    sizes: ({ filters }) => filters.sizes,
    height: ({ filters }) => filters.height,
    dimension: (state) => state.dimension,
  })

  const dimension = computed(filters.dimension)
  const sizes = computed(filters.sizes)
  const height = computed(filters.height)

  const customSize = computed(() => height.length > 0)

  return computed(() => ({
    badgeContent: sizes.value.length || 1,
    badgeCondition:
      sizes.value.length ||
      customSize.value ||
      dimension.value.height.max ||
      dimension.value.height.min ||
      dimension.value.width.max ||
      dimension.value.height.min ||
      false,
  }))
}
